import {useDefaultCookieDomain} from '@aboutyou/storage';
import {cleanUpSessionState, cleanupUserPersistedState} from '@aboutyou/user';
import {useCallback} from 'react';

export const useUpdateUserCacheOnLogout = () => {
  const cookieDomain = useDefaultCookieDomain();

  return useCallback(() => {
    cleanUpSessionState({cookieDomain});
    cleanupUserPersistedState({cookieDomain});
  }, [cookieDomain]);
};
